import React, { useState } from "react";
import "./Careers.css";
import { NavDropdown } from "react-bootstrap";
import { ReactComponent as LeftBg } from "images/background/hero-section-red-triangle.svg";
import { ReactComponent as RedShadow } from "images/background/software-solution-graphic-red.svg";
import { ReactComponent as RightBg } from "images/background/right-box-graphic.svg";
import { ReactComponent as LeftBox } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";

import WaitingFor from "components/Banner/WaitingFor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

import { getData } from "app/data";

export default function Index() {
  const careersData = getData("careers").positions.contents;
  const [activeId, setActiveId] = useState();
  const HeaderImage = getData("careers").header.svg;

  return (
    <div className="careers-page">
      <div className="page-header">
        <LeftBg className="left-bg" />
        <RightBg className="right-bg" />
        <RedShadow className="red-shadow-bg" />
        <div className="row">
          <div className="col-lg-7 col-sm-12">
            <div className="page-header-title">
              <h2>{getData("careers").header.title}</h2>
            </div>
            <div className="text">
              {getData("careers").header.text
                ? getData("careers").header.text.map((item) => (
                    <>
                      <p>{item}</p>
                      <br></br>
                    </>
                  ))
                : null}
            </div>
          </div>
          <div className="col-lg-5 col-sm-12 img">
            <HeaderImage className="logo" />
          </div>
        </div>
      </div>
      <section className="main-background">
        <div className="contents">
          <RightBox className="right-box-shape" />
          <LeftBox className="left-box-shape" />
          <div className="container">
            <h2 className="primary">{getData("careers").positions.title}</h2>
          </div>
          {careersData
            ? careersData.map((item) => {
                return (
                  <>
                    <ul>
                      <li className="container row mx-auto">
                        <div className="faq col-lg-12">
                          <span className="icon">
                            <FontAwesomeIcon icon={faChevronDown} />
                          </span>
                          <NavDropdown
                            title={item.title}
                            onClick={() => {
                              setActiveId(item.id);
                            }}
                          >
                            <div className="faq-content col-lg-9">
                              {item.desc ? (
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item.desc,
                                  }}
                                ></p>
                              ) : null}
                            </div>
                            <hr
                              className={item.id === activeId ? "none" : "show"}
                            />
                          </NavDropdown>
                        </div>
                        <hr />
                      </li>
                    </ul>
                  </>
                );
              })
            : null}
        </div>
      </section>
      <WaitingFor />
    </div>
  );
}
